import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { AppShellStore } from './app-shell.store';
import { LoginService } from './core/auth/login.service';
import { CountryDomainService } from './core/country/country-domain.service';
import { CountryCode, COUNTRY_LABELS } from './core/country/country.model';
import { StatusChipComponent } from './pages/customers/shared/status-chip.component';
import { AiAgentChatPanelComponent } from './shared/ai-agent-chat/ai-agent-chat-panel.component';

@Component({
    selector: 'na-root',
    imports: [
        RouterOutlet,
        RouterLink,
        RouterLinkActive,
        MatSidenavModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatListModule,
        MatSelectModule,
        MatExpansionModule,
        MatTooltipModule,
        AiAgentChatPanelComponent,
        StatusChipComponent,
    ],
    templateUrl: './app.html',
    styleUrl: './app.scss',
    providers: [AppShellStore],
})
export class AppComponent {
    protected readonly store = inject(AppShellStore);
    protected readonly countryDomainService = inject(CountryDomainService);
    protected readonly countryLabels = COUNTRY_LABELS;

    private readonly loginService = inject(LoginService);
    private readonly router = inject(Router);

    onCountryChange(country: CountryCode): void {
        this.countryDomainService.setCountry(country);
    }

    logout(): void {
        this.loginService.logout().subscribe({
            next: () => this.router.navigate(['/login']),
            error: () => this.router.navigate(['/login']),
        });
    }
}
